import { DateTime } from "luxon";
import UseStoreHandler from "./UseStoreHandler";

export default class DateHandler {
  /**
   * Gets avaliable presets for date formating
   * @returns 
   */
  static getDateFormatPresets(key = null) {
    const presets = {
      DATE_SHORT: DateTime.DATE_SHORT,           // 4/20/25
      DATE_MED: DateTime.DATE_MED,               // 20 de abr. de 2025
      DATE_FULL: DateTime.DATE_FULL,             // 20 de abril de 2025
      DATE_HUGE: DateTime.DATE_HUGE,             // domingo, 20 de abril de 2025
    
      TIME_SIMPLE: DateTime.TIME_SIMPLE,         // 20:48
      TIME_WITH_SECONDS: DateTime.TIME_WITH_SECONDS, // 20:48:39
      TIME_WITH_SHORT_OFFSET: DateTime.TIME_WITH_SHORT_OFFSET, // 20:48 UTC−3
      TIME_WITH_LONG_OFFSET: DateTime.TIME_WITH_LONG_OFFSET,   // 20:48 UTC−03:00
    
      DATETIME_SHORT: DateTime.DATETIME_SHORT,   // 4/20/25, 20:48
      DATETIME_MED: DateTime.DATETIME_MED,       // 20 de abr. de 2025 20:48
      DATETIME_FULL: DateTime.DATETIME_FULL,     // 20 de abril de 2025 20:48 BRT
      DATETIME_HUGE: DateTime.DATETIME_HUGE      // domingo, 20 de abril de 2025 20:48 BRT
    }

    return key && presets[key] ? presets[key] : presets;
  }

  static getUserLocale() {
    let languageIso = UseStoreHandler.getContextStore().getNavigatorLanguage;
    
    return languageIso;
    // return navigator.language.split('-')[0] ?? 'pt-BR';
  }

  static format(input, formatPreset = 'DATETIME_MED', options = {}) {
    const userLocale = this.getUserLocale();
    
    const dateTime = this.toDateTime(input);

    if (!dateTime.isValid) {
      console.error(`Falha ao parsear a data: ${input}. Razão: ${dateTime.invalidReason}`);
      return 'Data inválida';
    }

    const dtWithZone = options.zone ? dateTime.setZone(options.zone) : dateTime;

    const presetObject = this.getDateFormatPresets(formatPreset);

    return dtWithZone
      .setLocale(userLocale)
      .toLocaleString(presetObject);
  }

  static formatWithZone(sqlTimestamp, targetZone, formatPreset = DateTime.DATETIME_MED) {
    const userLocale = this.getUserLocale();

    return DateTime.fromSQL(sqlTimestamp, { zone: 'utc' })
      .setZone(targetZone)
      .setLocale(userLocale)
      .toLocaleString(formatPreset);
  }

  static formatCustom(sqlTimestamp, customFormat = 'dd/MM/yyyy HH:mm') {
    const userLocale = this.getUserLocale();

    return DateTime.fromSQL(sqlTimestamp)
      .setLocale(userLocale)
      .toFormat(customFormat);
  }

  static timeSince(sqlTimestamp, format = DateTime.DATE_SHORT, options = {zone: 'utc', maxRelativeDays: 7}) {
    options.formatPreset = format;
    const userLocale = this.getUserLocale();
  
    const dateTime = DateTime.fromSQL(sqlTimestamp, {
      zone: options.zone || 'local',
    }).setLocale(userLocale);
  
    const now = DateTime.now().setLocale(userLocale);
    const diffInDays = now.diff(dateTime, 'days').days;
  
    const formatPreset = options.formatPreset || DateTime.DATE_MED;
    const maxDays = options.maxRelativeDays || 7;
  
    if (Math.abs(diffInDays) <= maxDays) {
      return dateTime.toRelative({ base: now });
    } else {
      return dateTime.toLocaleString(formatPreset);
    }
  }

  /**
   * Tries to convert the unknow entry to a Luxo DateTime
   * @param {string|Date|DateTime} input 
   * @param {string|null} knownFormat - 'dd/MM/yyyy'
   */
  static toDateTime(input, knownFormat = null) {
    if (!input) {
      return DateTime.invalid('empty input');
    }
    if (input instanceof DateTime) {
      return input;
    }
    if (input instanceof Date) {
      return DateTime.fromJSDate(input);
    }

    if (knownFormat) {
      return DateTime.fromFormat(input, knownFormat);
    }

    let dt = DateTime.fromISO(input);
    if (dt.isValid) {
      return dt;
    }

    dt = DateTime.fromSQL(input);
    if (dt.isValid) {
      return dt;
    } 

    dt = DateTime.fromFormat(input, 'dd/MM/yyyy');
    if (dt.isValid) {
      return dt;
    }

    dt = DateTime.fromFormat(input, 'dd/MM/yyyy HH:mm:ss');
    if (dt.isValid) { 
      return dt;
    }

    return DateTime.invalid('Formato não reconhecido');
  }

  /**
   * Generate a valid DateTime Object
   */
  static toNativeDate(input, knownFormat = null) {
    const dt = this.toDateTime(input, knownFormat);
    return dt.isValid ? dt.toJSDate() : null;
  }

  /**
   * Parses any date to yyyy-MM-dd
   */
  static toISODate(input) {
    const dt = this.toDateTime(input);
    
    if (!dt.isValid) return null;

    return dt.toISODate(); 
  }

  static now() {
    return DateTime.now();
  }

  static nowDateFormated() {
    return DateHandler.now().toLocaleString(DateTime.TIME_24_WITH_SECONDS);
  }

  static diffInSeconds(date = null) {
    if (!date) return 0;

    const pastDate = (typeof date !== 'object') ? DateHandler.toNativeDate(date) : date;
    const now = new Date();
    
    const diffMs = now.getTime() - pastDate.getTime();
    return Math.floor(diffMs / 1000);
  }
}
